import { Button, ButtonGroup, Td, Tr, useDisclosure } from "@chakra-ui/react";
import { Dash, Heading, Icon, IconButton, Section, Table, Tag } from "components";
import { Moment } from "config";
import useEmployeeFiles from "hooks/useEmployeeFiles";
import { File } from 'screens'

export default function Files({ data }){

    const attachments = useEmployeeFiles(data?.id)
    const upload = useDisclosure()

    const columns = [{ children: '' }, { children: 'Arquivo' }, { children: 'Descrição', isNumeric: true }, { children: 'Tamanho', isNumeric: true }, { children: 'Data', isNumeric: true }, { children: '', isNumeric: true }]

    return(
    <>
    <Section title="Arquivos do colaborador">
        <ButtonGroup size="xs" isDisabled={attachments.isFetching}>
            <Button children="Enviar arquivo" leftIcon={<Icon name="upload" />} onClick={upload.onOpen} />
            <IconButton label="Atualizar" icon="refresh" isLoading={attachments.isFetching} onClick={attachments.refetch} />
        </ButtonGroup>
    </Section>

    <Table columns={columns} mt={6}>
        { attachments.data?.data?.map(item => <FileItem key={item.id} data={item} />) }
    </Table>

    {/* Screens */}
    <File.Upload {...upload} options={{ consultant_id: data?.id }} onSuccess={attachments.refetch} />
    </>
    )
}

const FileItem = ({ data }) => {
    return(
    <Tr>
        <Td isNumeric><Icon name={data.metadata?.extension} width={6} height={6} /></Td>
        <Td fontSize="xs" children={data.filename} />
        <Td><Dash children={data.label} /></Td>
        <Td isNumeric><Tag size="sm" children={data.size} /></Td>
        <Td isNumeric children={Moment(data.created_at).calendar()} />
        <Td isNumeric>
            <ButtonGroup size="xs">
                <IconButton label="Visualizar" icon="view" />
                <IconButton label="Download" icon="download" />
                <IconButton label="Excluir" icon="trash" colorScheme="red" variant="outline" />
            </ButtonGroup>
        </Td>
    </Tr>
    )
}